import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { AdvertiserContentArticle, NewsArticle } from "schema-dts";

import { useArticleSchemaContext } from "~/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "~/components/article/article-schema/types";

type Props = Record<string, never>;

export const AdvertiserContentArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<NewsArticle, AdvertiserContentArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["NewsArticle", "AdvertiserContentArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

AdvertiserContentArticleSchema.displayName = "AdvertiserContentArticleSchema";
